import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { useSystemStatus } from '@/lib/systemStatus';

export function StatusDot() {
  const { data, isError } = useSystemStatus();

  // Real health verdict (status = dot + text, never colour alone). Database
  // down is the hard failure; a configured-but-unreachable orchestrator
  // degrades classification; a null orchestrator is simply not configured.
  let dotClass = 'bg-ok';
  let label = 'Toate sistemele funcționale';
  if (isError || !data) {
    dotClass = 'bg-mute';
    label = 'Stare necunoscută';
  } else if (!data.database) {
    dotClass = 'bg-bad';
    label = 'Baza de date nu răspunde';
  } else if (data.orchestrator === false) {
    dotClass = 'bg-warn';
    label = 'Clasificarea este indisponibilă';
  }

  const orchestratorText = !data
    ? '—'
    : data.orchestrator === null
      ? 'neconfigurat'
      : data.orchestrator
        ? 'funcțional'
        : 'indisponibil';

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="inline-flex items-center gap-2 text-ink-3">
          <span className={`size-2 rounded-full ${dotClass}`} aria-hidden />
          <span className="text-[13.5px]">{label}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-60 text-[13.5px]">
        <dl className="space-y-1.5 text-ink-2">
          <div className="flex items-center justify-between gap-4">
            <dt>Server</dt>
            <dd className="text-ink">{data?.api ? 'funcțional' : '—'}</dd>
          </div>
          <div className="flex items-center justify-between gap-4">
            <dt>Bază de date</dt>
            <dd className="text-ink">{!data ? '—' : data.database ? 'funcțională' : 'indisponibilă'}</dd>
          </div>
          <div className="flex items-center justify-between gap-4">
            <dt>Clasificare</dt>
            <dd className="text-ink">{orchestratorText}</dd>
          </div>
        </dl>
      </PopoverContent>
    </Popover>
  );
}
